import React, { useContext, useState, useRef, useEffect } from "react";
import { withRouter } from "react-router";
import moment from "moment";
import { AuthContext } from "../App";
import { logout } from "../auth";

// Tap-to-expand session info panel. Shows username + role inline; on tap,
// drops a small panel below the chip with the user's role name and the
// orgs/facilities the JWT granted. Helps users confirm their authority
// context (TSP-129 follow-up).
const SessionChip = ({ user }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("touchstart", onDocClick);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("touchstart", onDocClick);
    };
  }, [open]);

  const orgs = user.allOrgs
    ? "All facilities"
    : (user.allowedOrgs && user.allowedOrgs.length > 0
        ? user.allowedOrgs.join(", ")
        : "None");

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-block", marginRight: 16 }}>
      <span
        onClick={() => setOpen((v) => !v)}
        style={{ cursor: "pointer", userSelect: "none" }}
        aria-label="Session info"
      >
        {user.displayName}
        {user.roleName ? (
          <span style={{ color: "rgba(255,255,255,0.6)", marginLeft: 6, fontSize: 12 }}>
            ({user.roleName})
          </span>
        ) : null}
      </span>
      {open && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 8px)",
            right: 0,
            minWidth: 220,
            maxWidth: 320,
            background: "#fff",
            color: "#1f2937",
            borderRadius: 6,
            boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
            padding: "10px 14px",
            fontSize: 12,
            lineHeight: 1.5,
            zIndex: 20,
            textAlign: "left",
            whiteSpace: "normal",
          }}
        >
          <div style={{ fontWeight: 600, marginBottom: 4 }}>{user.displayName}</div>
          {user.roleName && (
            <div>
              <span style={{ color: "#6b7280" }}>Role:</span> {user.roleName}
            </div>
          )}
          <div style={{ marginTop: 4, wordBreak: "break-word" }}>
            <span style={{ color: "#6b7280" }}>Facilities:</span> {orgs}
          </div>
        </div>
      )}
    </div>
  );
};

const Header = ({ location }) => {
  const user = useContext(AuthContext);
  const pathname = (location && location.pathname) || "";
  const isFirstPage = pathname === "/needsaction" || pathname === "/";

  return (
    <div style={{ padding: "10px 32px", display: "flex", alignItems: "center", background: "#1a472a", height: 64, boxSizing: "border-box" }}>
      <div style={{ flex: 1 }}>
        <div style={{ color: "#fff", fontSize: 22, fontWeight: 700, lineHeight: "26px" }}>
          TankView
        </div>
        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12, lineHeight: "16px" }}>
          {moment().format("dddd, MMMM D, YYYY")}
        </div>
      </div>
      {isFirstPage && (
        <div
          style={{
            color: "#fff",
            fontSize: 18,
            fontWeight: 600,
            letterSpacing: 0.3,
            whiteSpace: "nowrap",
          }}
        >
          TankView Internal Dashboard
        </div>
      )}
      {user && (
        <div style={{ flex: 1, textAlign: "right", color: "rgba(255,255,255,0.85)", fontSize: 13, whiteSpace: "nowrap" }}>
          <SessionChip user={user} />
          <span
            onClick={logout}
            style={{ color: "rgba(255,255,255,0.5)", cursor: "pointer", fontSize: 12 }}
          >
            Sign Out
          </span>
        </div>
      )}
    </div>
  );
};

export default withRouter(Header);
